import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import {
  MutationInput_OperationController_SaveStatus_Input_Value,
  useOperationSaveStatusMutation,
} from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { parseOperationEntity } from 'api/helpers/operation';
import { useNotifyMessages } from 'api/helpers/useNotifyMessages';
import { OperationStatusType } from 'api/types/entity/operation';

interface OperationSaveStatusParams {
  value: OperationStatusType;
  reason?: string;
}

export const useOperationSaveStatus = () => {
  const [saveStatus, { loading, error: apolloError }] =
    useOperationSaveStatusMutation();
  const error = useError(apolloError);

  const notifyMessage = useNotifyMessages();

  return {
    saveStatus: useCallback(
      async (
        id: string,
        versionNumber: number,
        params: OperationSaveStatusParams
      ) => {
        const res = await saveStatus({
          variables: {
            id,
            input: {
              versionNumber,
              value:
                MutationInput_OperationController_SaveStatus_Input_Value[
                  params.value
                ],
            },
          },
        });

        if (res.data?.saveStatus?.messages) {
          notifyMessage(res.data.saveStatus.messages);
        }

        return res.data?.saveStatus?.data
          ? parseOperationEntity(res.data?.saveStatus.data)
          : null;
      },
      [notifyMessage, saveStatus]
    ),
    loading,
    error,
  };
};
